<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_customers')">
      <button class="btn btn-primary" @click="create">{{ 'create' | t }}</button>
    </div>
    <div class="card">
      <div class="card-body" v-if="customer">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-group">
              <label>{{ 'Purchase for' | t }}</label>
              <input class="form-control" disabled="true" v-model="customer.name" />
            </div>
            <div class="form-group">
              <label>{{ 'product' | t }}</label>
              <select class="form-control" v-model="purchase.plan">
                <option v-for="plan in plans" :value="plan">{{ plan.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ 'description' | t }}</label>
              <input class="form-control" v-model="purchase.description" />
            </div>
            <div class="form-group">
              <label>{{ 'quantity' | t }}</label>
              <input class="form-control" v-model="purchase.quantity" type="number" min="0.5" step="0.5" />
            </div>
            <div class="form-group">
              <label>{{ 'unit_price' | t }}</label>
              <div class="input-group">
                <input class="form-control" v-model="purchase.unit_price" />
                <div class="input-group-append">
                  <div class="input-group-text">{{ customer.currency }}</div>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="purchase.quantity && purchase.unit_price">
              <label
                >{{ purchase.quantity }} X {{ purchase.unit_price }} = {{ purchase.quantity * purchase.unit_price }}
                {{ customer.currency }}</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts from '@/utils/alerts.js';

export default {
  props: ['customer_id'],
  data: function () {
    return {
      customer: null,
      loading: false,
      plans: [],
      purchase: {
        customer: { id: this.customer_id },
        unit_price: null,
        quantity: null,
        description: '',
        plan: null
      }
    };
  },
  methods: {
    async create() {
      Api.create('purchases', this.purchase)
        .then(() => {
          Alerts.success({ title: 'Success', detail: 'Purchase created' });
          this.$router.push({
            name: 'customers_show',
            params: { customer_id: this.customer_id }
          });
        })
        .catch(({ errors }) => {
          Alerts.danger({ title: errors[0].title, detail: errors[0].detail });
        });
    }
  },
  mounted: async function () {
    let { data: customer } = await Api.find('customers', this.customer_id);
    this.customer = customer;
    let { data: plans } = await Api.findAllPages('plans', {
      filter: { currency: customer.currency }
    });
    this.plans = plans;
    this.setBreadcrumbs([
      { to: { name: 'customers' }, text: 'Customers' },
      {
        to: { name: 'customers_show', customer_id: this.customer_id },
        text: this.customer.name
      },
      { to: {}, text: 'New purchase' }
    ]);
  }
};
</script>

<style scoped></style>
